<template>

    <Head title="Reset Password" />

    <div class="relative lg:fixed h-full shrink-0 justify-center md:px-12 lg:px-0 bg-white">
        <div
            class="relative z-10 flex flex-1 flex-col h-full bg-white px-4 py-10 shadow-2xl md:flex-none md:px-28 overflow-y-scroll overflow-x-hidden scrollbar-hide">
            <jet-authentication-card class="">
                <div class="flex justify-center items-center">
                    <jet-authentication-card-logo-colored />
                </div>

                <h1 class="text-lg font-semibold text-gray-900 text-center mt-5">
                    Reset Your Password
                </h1>

                <jet-validation-errors class="mt-4" />

                <form @submit.prevent="submit" class="mt-8">
                    <div>
                        <jet-label for="email" value="Email" />
                        <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required
                            autofocus />
                    </div>

                    <div class="mt-4">
                        <jet-label for="password" value="Password" />
                        <div class="relative mt-2 flex items-center">
                            <input :type="isShowPassword ? 'text' : 'password'" id="password" v-model="form.password"
                                class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block w-full" />
                            <div class="absolute inset-y-0 right-0 flex py-1.5 pr-1.5">
                                <button type="button" @click="isShowPassword = !isShowPassword"
                                    class="inline-flex items-center rounded border border-gray-200 px-1 font-sans text-xs"
                                    :class="isShowPassword ? 'text-gray-500' : 'text-blue-600'"><font-awesome-icon icon="fa-eye" /></button>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <jet-label for="password_confirmation" value="Confirm Password" />
                        <jet-input id="password_confirmation" :type="isShowPassword ? 'text' : 'password'"
                            class="mt-1 block w-full" v-model="form.password_confirmation" required
                            autocomplete="new-password" />
                    </div>

                    <div class="flex items-center justify-end mt-4">
                        <jet-button class="w-full -ml-2" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Reset Password
                        </jet-button>
                    </div>
                    <div class="mt-4">
                        <Link :href="route('login')" class="text-sm text-gray-900">
                            <font-awesome-icon :icon="faChevronLeft()" class="mr-3"></font-awesome-icon>Back to Login
                        </Link>
                    </div>
                </form>
            </jet-authentication-card>
        </div>
    </div>
    <div class="hidden md:flex lg:pl-72 h-screen rentrisk-sidebar-gradient"></div>
</template>
<script>
import { Head } from '@inertiajs/vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import { Link } from '@inertiajs/vue3';
import moment from "moment";
import JetNavLink from '@/Jetstream/NavLink.vue'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faChevronLeft} from "@fortawesome/pro-light-svg-icons";

export default {
    components: {
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetAuthenticationCardLogoColored,
        JetButton,
        JetInput,
        JetLabel,
        JetValidationErrors,
        Link,
        JetNavLink,
        FontAwesomeIcon,
        faChevronLeft
    },

    props: {
        email: String,
        token: String,
    },

    data() {
        return {
            currentYear: moment().year(),
            form: this.$inertia.form({
                token: this.token,
                email: this.email,
                password: '',
                password_confirmation: '',
            }),
            isShowPassword: false,
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('password.update'), {
                onFinish: () => this.form.reset('password', 'password_confirmation'),
            })
        },

        faChevronLeft() {
            return faChevronLeft
        },
    }
}
</script>
